import { PERSONAL_LOAN, BASE_PATH, ASSET_DOMAIN_URL } from 'gatsby-env-variables';

export const footerLinks = [
  [
    {
      label: 'Products',
      key: 'products',
      children: [
        {
          label: 'Personal Loan',
          link: PERSONAL_LOAN,
          key: 'pl',
        },
        {
          label: 'Education Loan',
          link: '/el',
          key: 'el',
        },
        {
          label: 'SME Business Loan',
          link: '/sme-loan/index.html',
          key: 'sme-business',
        },
        {
          label: 'Merchant Loan',
          link: `${BASE_PATH}merchant-loan/`,
          key: 'digital-msme',
        },
      ],
    },
  ],
  [
    {
      label: 'Company',
      key: 'company',
      children: [
        {
          label: 'About Us',
          link: `${BASE_PATH}about-us`,
          isPDF: false,
          key: 'aboutus',
        },
        {
          label: 'InCred in News',
          link: `${BASE_PATH}InCred-News`,
          isPDF: false,
          key: 'in-the-news',
        },
        {
          label: 'Team',
          link: `${BASE_PATH}Team`,
          isPDF: false,
          key: 'teams',
        },
        {
          label: 'Testimonials',
          link: `${BASE_PATH}testimonial`,
          isPDF: false,
          key: 'testimonials',
        },
        // {
        //   label: 'Podcasts',
        //   link: '/podcasts/',
        //   isPDF: false,
        //   key: 'podcasts',
        // },
        {
          label: 'Advisory Notes',
          link: `/docs/Advisory+Note+-+VISU.pdf`,
          isPDF: true,
          key: 'advisory-notes',
        },
        {
          label: 'Recovery Agents',
          link: `${BASE_PATH}recovery-agent`,
          isPDF: false,
          key: 'recovery-agents',
        },
        {
          label: 'Terminated Outsourcing Vendors',
          link: BASE_PATH + 'company/Terminated-Outsourcing-Vendors/',
          isPDF: false,
          key: 'terminated-outsourcing-vendors',
        },
        {
          label: 'Privacy Policy',
          link: `${BASE_PATH}privacy-policy`,
          isPDF: false,
          key: 'privacy-policy',
        },
        {
          label: 'Investor Relation',
          link: `${BASE_PATH}Investor-Relation`,
          isPDF: false,
          key: 'company-investor-relation',
        },
      ],
    },
  ],
  [
    {
      label: 'InCred Financial Services Limited',
      subheading: '(Formerly "KKR India Financial Services Limited")',
      key: 'incred-finance',
      children: [
        {
          label: 'Board of Directors',
          link: `${BASE_PATH}Board-Of-Director`,
          key: 'finance-board-of-directors',
        },
        {
          label: 'Corporate Details',
          link: `${BASE_PATH}visu-regulatory-details`,
          key: 'corporate-details',
        },
        {
          label: 'Resignation of Directors',
          link: `${BASE_PATH}resignation-notice`,
          key: 'resignation-of-directors',
        },
        {
          label: 'Auction Notices',
          link: `${BASE_PATH}auction-notices`,
          key: 'finance-auction-notices',
        },
        {
          label: 'CSR Committee',
          link: '/docs/CSR Committee.pdf',
          key: 'csr-committee',
        },
        {
          label: 'Policies',
          link: `${BASE_PATH}Policies`,
          key: 'policies',
        },
        {
          label: 'Sachet Portal of RBI',
          link: 'https://sachet.rbi.org.in/',
          isPDF: false,
          key: 'investorrelation',
        },
        {
          label: 'Regulatory',
          isDropDown: true,
          key: 'regulatory',
          children: [
            {
              label: 'List of KYC Documents',
              link: `${BASE_PATH}KYC`,
              key: 'regulatory-list-kyc',
            },
            {
              label: 'Rate of Interest',
              link: `${BASE_PATH}rate-of-interests`,
              key: 'regulatory-roi',
            },
            {
              label: 'Approach for Gradation of Risks ',
              link: `${BASE_PATH}gradation-of-risks`,
              key: 'gradation-of-risks',
            },
            {
              label: 'Consumer Education Literature',
              link: '/docs/Customer Education Literature- Final.pdf',
              key: 'consumer-eduction-literature',
            },
            {
              label: 'General T&C',
              link: `${BASE_PATH}terms-and-conditions-pl`,
              key: 'general-t-n-c',
            },
            {
              label: 'ECLGS Scheme',
              link: '/docs/ECLGS Document.pdf',
              key: 'regulatory-ECLGS',
            },
            {
              label: 'Patnerships',
              link: `${BASE_PATH}partnership`,
              key: 'regulatory-partnerships',
            },
            {
              label: 'Notices of General Meetings',
              link: '/EGM-notice.html',
              key: 'notices-of-general-meetings',
            },
            {
              label: 'Term of Use',
              link: `${BASE_PATH}term-of-use`,
              key: 'term-of-use',
            },
            {
              label: 'Composition of Committee',
              link: '/docs/Composition of Committee.pdf',
              key: 'composition-of-commitee',
            },
            {
              label: 'Secured assets possessed under the SARFAESI Act, 2002',
              link: `${BASE_PATH}sarfaesi`,
              key: 'sarfaesi',
            },
            {
              label: 'Operational Guideline for Handover of Collateral Documents in the case of Demise of Borrower.',
              link: `${ASSET_DOMAIN_URL}/doc/Footer/Regulatory/Procedure - Return of property documents.pdf`,
              key: 'sarfaesi',
            },
          ],
        },
      ],
    },
    {
      label: 'InCred Housing Finance Private Limited',
      isDropDown: true,
      display: false,
      key: 'incred-housing',
      children: [
        {
          label: 'Board of Directors',
          link: '../board-of-directors-bee-secure.html',
          key: 'housing-board-of-directors',
        },
        // {
        //   label: 'Fair Practice Code',
        //   link: '/fair-practice-code-beesecure.html',
        //   key: 'housing-fair-pratice-code',
        // },
        {
          label: 'List of KYC Documents',
          link: '/KYC.html',
          key: 'housing-list-kyc',
        },
        {
          label: 'MITC for Home Loans',
          link: '/MITC.html',
          key: 'housing-mitc',
        },
        // {
        //   label: 'Grivance Redressal Policy',
        //   link: '/grievance-bee-secure.html',
        //   key: 'housing-grivance',
        // },
        // {
        //   label: 'Corporate Goverance Guidelines',
        //   link: '/corporate_governance.html',
        //   key: 'housing-corporate-goverance',
        // },
        // {
        //   label: 'Policy on Related Party Transaction',
        //   link: '/related-party-policy-bee-secure.html',
        //   key: 'housing-policy-related-party',
        // },
        {
          label: 'T&C Of The Appointment Of Independent Directors',
          link: '/docs/Terms of appointment of ID.pdf',
          isPDF: true,
          key: 'housing-t-n-c',
        },
        {
          label: 'Resignation of Directors',
          link: `${BASE_PATH}resignation-notice`,
          key: 'housing-resignation-of-directors',
        },
        {
          label: 'Whistle Blower Policy',
          link: '/docs/Whistle Blower mechanism_2021.pdf',
          isPDF: true,
          key: 'housing-whistle-blower',
        },
        {
          label: 'Policy for appointment of Statutory Auditors',
          link: '/docs/Policy-for-Appointment-of-Statutory-Auditors_IFSL - Final.pdf',
          isPDF: true,
          key: 'housing-policy-appointment',
        },
        {
          label: 'Policy for Determining Interest Rates, Processing & other Charges',
          link: '/docs/Policy for Determining Interest Rates, Processing & other Charges.pdf',
          isPDF: true,
          key: 'housing-policy-detremining-interest-rate',
        },
        // {
        //   label: 'Investor Relations',
        //   link: '/Housing_Investor_Relations.html',
        //   key: 'housing-investor-relations',
        // },
      ],
    },
  ],
  [
    {
      label: 'InCred Holdings Limited',
      subheading: '(Formerly "KKR Capital Markets India Limited")',
      key: 'incredholdings',
      children: [
        {
          label: 'Board of Directors',
          link: BASE_PATH + 'InCred-Holding/Board-Of-Director/',
          isPDF: false,
          key: 'boardofdirectors',
        },
        {
          label: 'Company Information',
          link: BASE_PATH + 'InCred-Holding/Company-Information/',
          isPDF: false,
          key: 'companyinformation',
        },
        {
          label: 'Offer Documents',
          link: BASE_PATH + 'InCred-Holding/Offer-Document/',
          isPDF: false,
          key: 'offerdocuments',
        },
        {
          label: 'Investor Charter',
          link: BASE_PATH + 'InCred-Holding/Investor-Charter/',
          isPDF: false,
          key: 'investorcharter',
        },
        {
          label: 'Complaint Status',
          link: BASE_PATH + 'InCred-Holding/Complaint-Status/',
          isPDF: false,
          key: 'complaintstatus',
        },
        {
          label: 'Policies',
          link: BASE_PATH + 'InCred-Holding/Policies/',
          isPDF: false,
          key: 'policies',
        },
        {
          label: 'Investor Relation',
          link: BASE_PATH + 'InCred-Holding/Investor-Relations/',
          isPDF: false,
          key: 'investorrelation',
        },
      ],
    },
  ],
  [
    {
      label: 'Locate Us',
      key: 'locate-us',
      children: [
        {
          label: 'Our Addresses and Locations',
          link: `${BASE_PATH}contact-us/`,
          key: 'locate-offices',
        },
      ],
    },
    {
      label: 'Support',
      key: 'supports',
      children: [
        {
          label: 'FAQ',
          link: '/faq.html',
          key: 'support-faq',
        },
        {
          label: 'Ombudsman Scheme',
          link: '/ombudsman.html',
          key: 'ombudsman',
        },
        {
          label: 'Careers',
          link: `${BASE_PATH}Career-Page/`,
          key: 'careers',
        },
      ],
    },
    {
      label: 'Follow Us',
      icon: true,
      key: 'follow-us',
    },
  ],
];
